export default {"src":"/intl/_next/static/media/shopping_cart.d15a1689.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};